import React from 'react';

import classNames from 'classnames/bind';
import style from './Header.scss';
const ctx = classNames.bind(style);

import Spreader from '../Spreader';
import Logo from './blocks/Logo';
import Menu from './blocks/Menu';
import Title from './blocks/Title';

import { withRouter } from 'react-router';

@withRouter
class Header extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        <div className={ctx('flex')} />
        <div className={ctx('header')}>
          <Spreader>
            <div className={ctx('inner')}>
              <div className={ctx('logo')}>
                <Logo />
              </div>
              <div className={ctx('title')}>
                <div className={ctx('desktop-title')}>
                  <Title />
                </div>
              </div>
              <div className={ctx('menu')}>
                <Menu />
              </div>
            </div>
            <div className={ctx('mobile-title')}>
              <Title />
            </div>
          </Spreader>
        </div>
      </div>
    );
  }
}

export default Header;
